import { IUser } from 'features/auth/types'
import storage, { StorageEnum } from './storage'
import { IDownloadCSV } from './types'

const hRange = [0, 360]
const sRange = [50, 75]
const lRange = [60, 80]
type HSL = [number, number, number]

export const OUTBOUND_AI = 'outbound.ai'

export const getHashOfString = (str: string) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  hash = Math.abs(hash)
  return hash
}

export const normalizeHash = (hash: number, min: number, max: number) => {
  return Math.floor((hash % (max - min)) + min)
}

export const generateHSLString = (name: string): string => {
  const hash = getHashOfString(name)
  const h = normalizeHash(hash, hRange[0], hRange[1])
  const s = normalizeHash(hash, sRange[0], sRange[1])
  const l = normalizeHash(hash, lRange[0], lRange[1])
  const hsl = HSLtoString([h, s, l])
  return hsl
}

export const HSLtoString = (hsl: HSL) => {
  return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`
}

export function ouAssert(condition: any, msg: string): asserts condition {
  if (!condition) throw new Error(msg)
}

export function longTextToSmall(text: string | undefined, totalChar: number, len: number): string {
  if (!text) {
    return ''
  }
  const totalLength = text?.length
  if (totalChar === 0 && len === 0) {
    return text
  }
  if (totalLength <= len) {
    return text
  }

  const firstChar = text?.slice(0, totalChar)
  const lastChar = text?.slice(-totalChar)

  return `${firstChar}...${lastChar}`
}

export function longTextTruncate(text: string, totalChar: number): string {
  const totalLength = text?.length
  if (totalLength <= totalChar) {
    return text
  }

  const firstChar = text?.slice(0, totalChar)

  return `${firstChar}...`
}

export function getMinValue(arr: Array<any> | undefined) {
  if (!arr || arr.length <= 0) {
    return undefined
  }

  let minValue = arr[0].value
  arr.forEach((ar: any) => {
    if (ar.value < minValue) {
      minValue = ar.value
    }
  })

  return minValue
}

export const downloadFile = (downloadData: IDownloadCSV) => {
  const blob = new Blob([downloadData.data], { type: downloadData.fileType })
  const a = document.createElement('a')
  a.download = downloadData.fileName
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}

export const isCurrentUserOutboundUser = () => {
  const userWorkEmail: IUser = storage.get(StorageEnum.currentUser)
  const email = userWorkEmail?.email?.split('@')[1]?.toLocaleLowerCase() === OUTBOUND_AI
  return email
}

export const getFileName = (headers: any) => {
  return headers['content-disposition'].split(';')[1].split('=')[1].replace(/"/g, '')
}

export const getInitials = (firstName: string, lastName: string) => {
  const initials = `${firstName?.charAt(0)?.toUpperCase()}${lastName?.charAt(0)?.toUpperCase()}` || ''
  return initials
}
